export function formatCurrencyPretty(
  value,
  currency = "PLN",
  locale = undefined,
  decimals = undefined,
) {
  if (value === null || value === undefined) return "-";
  const cur = String(currency || "PLN").toUpperCase();
  const localeToUse =
    locale ||
    (typeof navigator !== "undefined"
      ? navigator.language || "pl-PL"
      : "pl-PL");
  try {
    // prefer symbol for common currencies, otherwise show code
    const useSymbol = ["PLN", "EUR", "USD", "GBP"].includes(cur);
    const nfOptions = {
      style: "currency",
      currency: cur,
      currencyDisplay: useSymbol ? "symbol" : "code",
    };
    if (typeof decimals === "number") {
      nfOptions.minimumFractionDigits = decimals;
      nfOptions.maximumFractionDigits = decimals;
    }
    const fmt = new Intl.NumberFormat(localeToUse, nfOptions);
    let out = fmt.format(Number(value || 0));
    // Ensure specific symbols when Intl doesn't provide them in certain locales
    const symbolMap = { PLN: "zł", EUR: "€", GBP: "£", USD: "$" };
    const wanted = symbolMap[cur];
    if (wanted) {
      if (cur === "PLN") {
        // show 'zł' only for Polish locales; elsewhere prefer the currency code 'PLN'
        const isPolishLocale = String(localeToUse || "")
          .toLowerCase()
          .startsWith("pl");
        if (isPolishLocale) {
          if (!out.includes(wanted)) {
            out = out.replace(new RegExp(cur, "g"), wanted);
            if (!out.includes(wanted)) {
              out = `${out} ${wanted}`;
            }
          }
        } else {
          // Ensure we display the code 'PLN' in non-Polish locales
          // Replace any occurrence of localized 'zł' with 'PLN', and append if missing
          out = out.replace(/zł/g, "PLN");
          if (!out.includes("PLN")) {
            out = `${out} PLN`;
          }
        }
      } else {
        // For other currencies prefer symbol when Intl didn't provide it
        if (!out.includes(wanted)) {
          out = out.replace(new RegExp(cur, "g"), wanted);
          if (!out.includes(wanted)) {
            out = `${out} ${wanted}`;
          }
        }
      }
    }
    return out;
  } catch (e) {
    try {
      return `${Number(value || 0).toFixed(typeof decimals === "number" ? decimals : 2)} ${cur}`;
    } catch (err) {
      return String(value);
    }
  }
}

export default formatCurrencyPretty;
